class ErrorResponse {
  #data: any = null;

  constructor( message: string) {
    if (message.startsWith("{") || message.startsWith("[")) {
      this.#data = JSON.parse(message);
    }
  }

  get Data() {
    return this.#data;
  }
}

export { ErrorResponse };
